const EU_LOCALE = 'en-GB';

const DATE_OPTIONS = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
};

const DATE_TIME_OPTIONS = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false
};

export function formatEuDate(value, fallback = '—') {
  if (!value) return fallback;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return new Intl.DateTimeFormat(EU_LOCALE, DATE_OPTIONS).format(date);
}

export function formatEuDateTime(value, fallback = '—') {
  if (!value) return fallback;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return new Intl.DateTimeFormat(EU_LOCALE, DATE_TIME_OPTIONS).format(date);
}
